// extracted by mini-css-extract-plugin
export default {"link":"NoResultWish_link__Vv-OY"};